import { useQuery, UnusedSkipTokenOptions } from '@tanstack/react-query'
import {
	SearchUsersForRematchParams,
	SearchUsersForRematchResponse,
} from '@/modules/transaction/types'
import { querySearchUsersForRematchOptions } from './options'

export default function useQuerySearchUsersForRematch(
	payload: SearchUsersForRematchParams,
	options?: UnusedSkipTokenOptions<SearchUsersForRematchResponse>,
) {
	return useQuery(querySearchUsersForRematchOptions(payload, options))
}
